module.exports = __webpack_public_path__ + "static/img/ent-94.67d8497.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-94.jpg
// module id = xWYY
// module chunks = 52